module.exports = __webpack_public_path__ + "img/baimo.b46ef275.jpg";